<template>
	<div>
		<div class="donut-chart" :class="[chart_class, display]">
			<template v-if="goal_progress < .5">
				<div class="slice one" :style="'transform: rotate(' + rotation + 'deg);'"></div>
				<div class="slice two" style="transform: rotate(0deg);"></div>
			</template>

			<template v-else>
				<div class="slice one" style="transform: rotate(90deg);"></div>
				<div class="slice two" :style="'transform: rotate(' + rotation + 'deg);'"></div>								
			</template>

			<div class="chart-center">
				<span v-if="goal_progress >= 1">
					<div class="goal-complete leading-normal font-weight-bold text-green-500">
						<i class="fas fa-check" :class="display == 'compact' ? 'text-lg pt-1' : 'text-3xl pt-3'"></i>
						<div :class="{ 'text-xs leading-none' : display == 'compact' }">{{ Math.round(goal_progress * 100) }}%</div>
					</div>
				</span>

				<span v-else>
					<div :class="display == 'compact' ? 'text-sm leading-none pt-2' : 'text-2xl mt-3'">
						{{ Math.round(goal_progress * 100) }}%
					</div>
					<span class="text-gray-600 leading-none" :class="display == 'compact' ? 'text-xs' : 'text-sm'">
						<strong>{{ segment.goal_type == 'charge' ? numeral(segment.target - segment.matching_checkins).format('$0a') : segment.target - segment.matching_checkins }}</strong> to go</span>


					</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['segment', 'display'],

		computed: {
			goal_progress() {
				return this.segment.matching_checkins / this.segment.target;
			},

			rotation() {
				if (this.goal_progress < .5) {
					return (this.goal_progress * 360) + 90;
				}
				else {
					return this.goal_progress * 360;
				}
			},

			chart_class() {
				if (this.goal_progress >= 1) {
					return 'finished';
				}
				if (this.goal_progress < .5) {
					return 'less-than-half';
				}
				else {
					return '';
				}
			}
		}
	}
</script>